import { render } from "./MainContent.vue?vue&type=template&id=11856b8a&scoped=true"
import script from "./MainContent.vue?vue&type=script&lang=js"
export * from "./MainContent.vue?vue&type=script&lang=js"

import "./MainContent.vue?vue&type=style&index=0&id=11856b8a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-11856b8a"

export default script